import React from 'react';
import PrivateRoute from '../../components/common/PrivateRoute';
import {Switch, Route} from 'react-router-dom';
import PageError from "../../components/layout/PageError";
import Dashboard from "../../pages/authorized/Dashboard";
import Member from "../../pages/authorized/Team/Member";
import Applicant from "../../pages/authorized/Applicant";

const Private = () => {

    return (
        <Switch>
            <PrivateRoute exact path="/dashboard" component={Dashboard} />
            <PrivateRoute exact path="/member" component={Member} />
            <PrivateRoute exact path="/opportunity/:id" component={Applicant} />
            <Route component={PageError} />
        </Switch>
    )
};

export default Private;
